import { Http } from './http';

export * from './xhr';

export * as transformers from './transformers';

export default new Http();